import {Box} from '@mui/material';
import styled from 'styled-components';

const AppContainer = styled.div`
  width: 100%;
  background-color: #fafafa;
`;

export const MainWrapper = styled(Box)<{$isSmartForm?: boolean}>`
  flex: 1;
  margin-left: ${(props) =>
    props.$isSmartForm ? 'calc(235px + 24px)' : 'calc(235px + 100px)'};

  @media (max-width: 1120px) {
    padding: 0;
    margin-left: ${(props) =>
      props.$isSmartForm ? 'calc(84px + 24px)' : 'calc(84px + 100px)'};
    margin-right: 0;
  }

  @media (max-width: 850px) {
    padding: 0;
    margin-left: ${(props) =>
      props.$isSmartForm ? 'calc(50px + 24px)' : 'calc(50px + 100px)'};
    margin-right: 0;
  }

  //? info this is always bellow of all css
  @media (max-width: 480px) {
    padding: 0;
    margin-left: 0;
    margin-right: 0;
  }
`;

export const PageContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  .dashboard-container {
    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;
export default AppContainer;
